import { HTMLProps } from "react";

interface Props extends HTMLProps<HTMLButtonElement> {
  // type from HTMLProps and button are not compatible :(
  type?: "button" | "submit" | "reset" | undefined;
  loading?: boolean;
  variant?: "contained" | "text" | "outline" | "lightContained";
}

const Button: React.FC<Props> = ({ className, children, loading, variant = "contained", ...rest }) => {
  const variantClassess = {
    contained: `text-pkc-white ${rest.disabled ? "bg-pkc-secondary " : "bg-pkc-primary "}`,
    text: `bg-transparent ${rest.color ? rest.color : "text-pkc-primary"}`,
    outline: "text-blue-800  border-2  border-blue-800 ",
    lightContained: " bg-pkc-primary-15 text-pkc-primary",
  };
  return (
    <button className={`p-2.5 rounded focus:outline-none ${variantClassess[variant]} ${className} `} {...rest}>
      {children}
      {loading && (
        <span className="pr-1">
          <i className="fa fa-spinner animate-spin" />
        </span>
      )}
    </button>
  );
};

export default Button;
